import React, { ChangeEventHandler, HTMLInputTypeAttribute, ReactNode } from 'react';
import { TextInput as MantineTextInput, MantineStyleProps } from '@mantine/core';
import textInputClasses from './TextInput.module.css';

type Props = {
  id?: string;
  required?: boolean;
  withAsterisk?: boolean;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  name?: string;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  type?: HTMLInputTypeAttribute;
  value?: string | readonly string[] | number | undefined;
  error?: React.ReactNode;
  rightSection?: ReactNode;
  autoFocus?: boolean;
} & MantineStyleProps;

export default function TextInput({
  id,
  required,
  withAsterisk,
  label,
  placeholder,
  disabled,
  name,
  onChange,
  type,
  value,
  error,
  rightSection,
  autoFocus,
  ...props
}: Props) {
  return (
    <MantineTextInput
      id={id}
      required={required}
      withAsterisk={withAsterisk}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      name={name}
      onChange={onChange}
      classNames={textInputClasses}
      type={type}
      value={value}
      error={error}
      rightSection={rightSection}
      autoFocus={autoFocus}
      {...props}
    />
  );
}
